// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoiceRuleSchema = z.object({
  id: z.number().int().describe("Unique identifier for the invoice rule"),
  account: z.object({}).describe("Associated account"),
  invoice_method: z.coerce.string().describe("Invoice method (manual or automatic)"),
  standard_invoice_date: z.coerce.string().describe("Standard invoice date (first_of_month or last_of_month)"),
  invoice_by: z.coerce.string().describe("Invoice grouping (client or project)"),
  list_item_grouping: z.coerce.string().describe("Line item grouping method"),
  created_at: z.string().datetime().describe("Creation timestamp"),
  updated_at: z.string().datetime().describe("Last update timestamp"),
});
